import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function StorePaymentItem(props){
    const[data]=useState(props.item)
    const navigate=useNavigate();
    const storeSettlement=()=>{
        navigate("/settlementPopUp")
    }
    const storeInfoPage = () => {
        // dispatch(updateFormInfo({ displayForm: false, formData: { product } }));
        navigate("/uniqueStore", {
          state: {
            storeId: data.storeId,
            storeName: data.storeName,
            storeAddress: data.deliveryCity,
            event:"orderWisePayments"
          },
        });
      };

    
    return(
        <>
        <tr>
            <td>{props.sno}</td>
            <td>{data.duration}</td>
            <td onClick={storeInfoPage}>
               <Link> {data.storeName}</Link>
                </td>
            
            <td>{data.ordersCount}</td>
            <td>{(+data.storePayment)-(+data.tax)}</td>
            <td>{data.tax}</td>
            <td>{data.storePayment}</td>
            
            <td>{data.transaction_date }</td>
            <td>{data.transaction_id===""?"-----":data.transaction_id}</td>
            <td>{data.payment_status==="PENDING"?<button className="btn dashboard-div-bg" onClick={storeSettlement}>Update</button>:data.payment_status}</td>
        </tr>
        </>
    )
}
export default StorePaymentItem;